export const GET_ASSETS = "GET_ASSETS";
export const MODIFY_ASSETS = "MODIFY_ASSETS";
export const ADD_ASSET = "ADD_ASSET";
export const EDIT_ASSET = "EDIT_ASSET";
export const DELETE_ASSET = "DELETE_ASSET";
